"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JILErrorCodes = exports.JilSortOrder = void 0; // The string values that JIL expects for Sort Order attributes.

var JilSortOrder;

(function (JilSortOrder) {
  JilSortOrder["ASC"] = "ASC";
  JilSortOrder["DESC"] = "DESC";
})(JilSortOrder = exports.JilSortOrder || (exports.JilSortOrder = {}));
/**
 * Enum for error codes thrown when calling JIL API
 */


var JILErrorCodes;

(function (JILErrorCodes) {
  JILErrorCodes["AUTHSRC_EXTERNALLY_MANAGED"] = "AUTHSRC_EXTERNALLY_MANAGED";
  JILErrorCodes["AUTHSRC_NOT_OWNED_BY_ORG"] = "AUTHSRC_NOT_OWNED_BY_ORG";
  JILErrorCodes["DIRECTORY_ENCRYPTED"] = "DIRECTORY_ENCRYPTED";
  JILErrorCodes["DIRECTORY_TRANSFER_TERMINATED_FOR_TRUSTS"] = "DIRECTORY_TRANSFER_TERMINATED_FOR_TRUSTS";
  JILErrorCodes["DIRECTORY_TYPE2E"] = "DIRECTORY_TYPE2E";
  JILErrorCodes["INVALID_DIRECTORY_TRANSFER_TARGET_ORG"] = "INVALID_DIRECTORY_TRANSFER_TARGET_ORG";
  JILErrorCodes["ORG_HAS_ESM"] = "ORG_HAS_ESM";
  JILErrorCodes["ORG_PENDING_ESM_MIGRATION"] = "ORG_PENDING_ESM_MIGRATION";
  JILErrorCodes["ORG_PENDING_T2E_MIGRATION"] = "ORG_PENDING_T2E_MIGRATION";
  JILErrorCodes["ORG_TYPE2E_WITH_USERS"] = "ORG_TYPE2E_WITH_USERS";
  JILErrorCodes["PROVISIONAL_ORG"] = "PROVISIONAL_ORG";
  JILErrorCodes["RENGA_ORG_AUTH_SRC_DELETE_TRUST_ERROR"] = "RENGA_ORG_AUTH_SRC_DELETE_TRUST_ERROR";
  JILErrorCodes["SOURCE_ORG_ENCRYPTED"] = "SOURCE_ORG_ENCRYPTED";
  JILErrorCodes["TARGET_ORG_ENCRYPTED"] = "TARGET_ORG_ENCRYPTED";
})(JILErrorCodes = exports.JILErrorCodes || (exports.JILErrorCodes = {}));